'use strict';

export default class Slider {
  constructor (slider) {
    this.id = slider.id;
    this.image = slider.image;
    this.title = slider.title;
    this.description = slider.description;
    this.link = slider.link;
    this.status = false;
  }
};



// WEBPACK FOOTER //
// ./src/models/class/slider-class.js